import * as types from '../../mutation-types'

const mutations = {
  [types.SET_ALERT] (state, { alert }) {
    state.alert =  alert
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/Alert/mutations.js